import React, { useContext } from "react";
import FocusLock from "react-focus-lock";

import { HasbotContext } from "../context/hasBot-context";
import { AiSmeChat } from "../hooks/useAiSmeChat";
import { DialogWrapper } from "./HelpAndSupportDialog.elements";
import { AiSmeChatDialog } from "./HelpAndSupportPages/AiSmeChatDialog";
import { HelpAndSupportMainPage } from "./HelpAndSupportPages/HelpAndSupportMainPage";
import { TechSupportMessageDialog } from "./HelpAndSupportPages/TechSupportMessageDialog";
import { ZopimChat } from "./HelpAndSupportPages/ZopimChat";

interface HelpAndSupportDialogProps {
  readonly className?: string;
  readonly chat: AiSmeChat;
}

function HelpAndSupportDialog({ className, chat }: Readonly<HelpAndSupportDialogProps>): React.ReactElement {
  const { techSupportActive, zopimChatActive, aiChatActive } = useContext(HasbotContext);

  return (
    <FocusLock>
      <DialogWrapper id="DIALOG-WRAPPER" role="dialog" aria-label="Help & Support" className={className}>
        {aiChatActive && <AiSmeChatDialog chat={chat} />}
        {zopimChatActive && <ZopimChat />}
        {techSupportActive && <TechSupportMessageDialog />}
        {!aiChatActive && !zopimChatActive && !techSupportActive && <HelpAndSupportMainPage />}
      </DialogWrapper>
    </FocusLock>
  );
}

export default HelpAndSupportDialog;
